module.exports = __webpack_public_path__ + "img/017-koala.cdbc8136.svg";